import React from 'react';
import T from 'i18n-react';
import camelCase from 'lodash/camelCase';
import curry from 'lodash/curry';

import { triggerCheckboxGroupFilterSetEvent } from 'Services/analytics/events';
import { useFilters, useSetFilter } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

import { SELLER_TYPES, VEHICLE_LIST_FILTER_NAME, VEHICLE_LIST_FILTERS_ID } from '../../VehicleListFilters.consts';
import CheckboxGroupFilterView from '../CheckboxGroup/CheckboxGroupFilterView';
import { SellerTypesOptions } from '../Filters.helpers';

T.setTexts(require('Components/texts.json'));

const { SELLER_TYPE } = VEHICLE_LIST_FILTER_NAME;

const SellerTypeFilter = () => {
	const filters = useFilters();
	const setFilter = useSetFilter();
	const isExLeaseBrandingEnabled = useFeatureToggle(FEATURES.exLeaseBranding);
	const isPartnerVisibilityEnabled = useFeatureToggle(FEATURES.partnerVehicleVisibility);

	const sellerTypesOptions = isPartnerVisibilityEnabled
		? SellerTypesOptions.filter((type) => type !== SELLER_TYPES.TRADE)
		: SellerTypesOptions.filter((type) => type !== SELLER_TYPES.FLEET);

	const sellerTypeCheckboxOptions = sellerTypesOptions
		.map((value) => ({
			label: T.translate(`vehicleList.filters.${VEHICLE_LIST_FILTERS_ID[SELLER_TYPE]}.${camelCase(value)}`),
			value,
		}))
		.map((option) => {
			if (option.value === SELLER_TYPES.FLEET) {
				return { ...option, label: T.translate('vehicleList.filters.sellerTypes.mobilize') };
			}
			if (isExLeaseBrandingEnabled && option.value === SELLER_TYPES.TRADE) {
				return { ...option, label: T.translate('vehicleList.filters.sellerTypes.mobilize') };
			}
			return option;
		});

	const handleOnClick = curry((section, clickedOption, value, currentlySelected) => {
		setFilter({ id: section, value: [...currentlySelected] });

		if (!clickedOption) {
			return;
		}

		triggerCheckboxGroupFilterSetEvent({ clickedOption, section, value });
	});

	return (
		<CheckboxGroupFilterView
			defaultExpanded
			checked={[...filters.sellerType]}
			columns={{ desktop: 3, mobile: 3 }}
			id={VEHICLE_LIST_FILTERS_ID[SELLER_TYPE]}
			name={SELLER_TYPE}
			onClick={handleOnClick(SELLER_TYPE)}
			options={sellerTypeCheckboxOptions}
			title={T.translate('vehicleList.filters.stockType')}
		/>
	);
};

export default SellerTypeFilter;
